let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("eWlhh")]).then(() => parcelRequire('3RRKD'));